import { render } from "./UserUpdatePage.vue?vue&type=template&id=3bc9ec03&ts=true"
import script from "./UserUpdatePage.vue?vue&type=script&lang=ts"
export * from "./UserUpdatePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__